module.exports = __webpack_public_path__ + "assets/img/fbc38d6fe14c6b396a31fcfaabd8b0ba.png";